import { render, staticRenderFns } from "./authorityPopupContentTop.vue?vue&type=template&id=4c4cefc5&"
import script from "./authorityPopupContentTop.vue?vue&type=script&lang=ts&"
export * from "./authorityPopupContentTop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports